import React from 'react';

const IconMenu = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 10h12M1.5 4h17M1.5 16h17" stroke="#111" strokeWidth="1.5" />
  </svg>
);

export default IconMenu;
